import { useLazyGetAllTeamsQuery } from '@/services/tenant/teamManagement'

export const useTeamsOptions = () => {
    const [getTeams, { data: teamsData }] = useLazyGetAllTeamsQuery()
    const loadOptionsTeams = async (
        search: string,
        loadedOptions: any,
        { page }: { page: number },
    ) => {
        const res = await getTeams(`page=${page}&search=${search}`).unwrap()

        return {
            options:
                res?.data.map(team => ({
                    value: team.team.id,
                    label: team.team.name,
                })) || [],
            hasMore: +page !== res?.pagination?.maxPages, // флаг, показывающий, есть ли еще данные
            additional: {
                page: page + 1, // увеличиваем номер страницы для следующего запроса
            },
        }
    }

    return { loadOptionsTeams, teamsData }
}
